import { render, staticRenderFns } from "./FileBrowserDialog.vue?vue&type=template&id=54222001&scoped=true"
import script from "./FileBrowserDialog.vue?vue&type=script&lang=js"
export * from "./FileBrowserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54222001",
  null
  
)

export default component.exports